import React, {useEffect, useState} from 'react'
import {NumericFormat} from 'react-number-format'

interface PaymentAmountInputProps {
  amount: number
  className?: string
  label?: string
  maxAmount: number
  disable: boolean
  onPaymentAmountChange: (amount: number) => void
}

const PaymentAmountInput = ({
  amount,
  className,
  label = 'Payment Amount',
  maxAmount,
  disable,
  onPaymentAmountChange
}: PaymentAmountInputProps) => {
  const [payAmount, setPayAmount] = useState(amount || 0)

  useEffect(() => {
    if (amount !== payAmount) {
      setPayAmount(amount)
    }
  }, [amount])

  return (
    <div className={className}>
      <div className="form-control">
        <label className="label label-text">{label}</label>
        <NumericFormat
          className="input input-primary w-1/2"
          value={payAmount}
          thousandSeparator={true}
          allowNegative={false}
          allowLeadingZeros={false}
          decimalScale={2}
          prefix={'$'}
          disabled={disable}
          onValueChange={({value}) => {
            const valueAmount = parseFloat(value)
            onPaymentAmountChange(valueAmount)
            setPayAmount(valueAmount)
          }}
          isAllowed={values => {
            const {floatValue} = values
            return !floatValue || floatValue < maxAmount
          }}
        />
      </div>
    </div>
  )
}

export default PaymentAmountInput
